import React, { useRef, useMemo } from "react"
import Modal from '@/components/Modal'
import { useTranslation } from "@/langs/useTranslation";
import { CMSContentDatatable } from "./CMSContentDatatable";
import {
  Box,
  Button,
  Typography
} from "@material-ui/core";

/**
 * status 1待审核 2审核中 3审核通过 4审核失败
 */
const CMSContentSelector = ({ open, onClose, onConfirm, status, type = "", single, selectedIds=[], selectedDisable=true }) => {
  const { t } = useTranslation()
  const tableRef = useRef(null)
  const mimeType = useMemo(() => {
    if (type === "") return []
    if (type === "image") return ["image/png", "image/jpeg"]
    if (type === "video") return ["video/mp4", "video/quicktime"]
    return []
  }, [type])

  // useEffect(() => {
  //   mimeTypeParams.current = mimeType
  // }, [mimeType])

  const mimeTypeParams = useRef(mimeType || [])

  const changeMimeType = type => {
    mimeTypeParams.current = type
    if (tableRef.current) tableRef.current.reload()
  }

  const getSearchParams = () => {
    const statusValue = status === undefined ? undefined : [status]
    return {
      mimeType: mimeTypeParams.current,
      statuses: statusValue
    }
  }

  const onModalConfirm = () => {
    const selectedRows = tableRef.current.getSelectedRows();
    if (onConfirm) onConfirm(selectedRows)
    if (onClose) onClose()
  }

  // const handleChecked = () => {
  //   const table = tableRef.current.api()
  //   window.test = table
  //   table.data().toArray().forEach((row, ind) => {
  //     if (selectedIds.indexOf(row.id) >= 0) {
  //       console.log(row.id, ind,'!!!')
  //       table.rows(ind).column(0).checkboxes.select(true)
  //     }
  //   })
  //   // tableRef.current.selectAll()
  // }

  return (
    <Modal
      open={open}
      onClose={onClose}
      onConfirm={onModalConfirm}
      title={t({ defaultMessage: "选择内容" })}
      titleStyle={{padding: "0px 0px"}}
      width={1200}
    >
      <Typography>
        {t({defaultMessage: "请先上传文件至资源管理中心。模板只能使用审核通过的文件。"})}
      </Typography>
      <Box display="flex" style={{ marginBottom: 32, marginTop: 16 }}>
        {type === "" && (
          <>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => changeMimeType([])}
            >
              {t({ defaultMessage: "全部" })}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => changeMimeType(["image/png", "image/jpeg"])}
              style={{ marginLeft: 16 }}
            >
              {t({ defaultMessage: "图片" })}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => changeMimeType(["video/mp4", "video/quicktime"])}
              style={{ marginLeft: 16 }}
            >
              {t({ defaultMessage: "视频" })}
            </Button>
          </>
        )}
        {type === "image" && (
          <Button
            variant="outlined"
            color="primary"
            // onClick={() => changeMimeType(["image/png", "image/jpeg"])}
          >
            {t({ defaultMessage: "图片" })}
          </Button>
        )}
        {type === "video" && (
          <Button
            variant="outlined"
            color="primary"
            // onClick={() => changeMimeType(["image/png", "image/jpeg"])}
          >
            {t({ defaultMessage: "视频" })}
          </Button>
        )}
      </Box>
      <CMSContentDatatable selectedDisable={selectedDisable} single={single} getSearchParams={getSearchParams} ref={tableRef} selectedIds={selectedIds} />
    </Modal>
  )
}

export default CMSContentSelector

